class BonusDeal {

    constructor(element) {

        this.element = element;

        this.id = this.element.data('bonus_deal_id');
        this.display_after_type = this.element.data('display_after_type');
        this.display_after_value = this.element.data('display_after_value');
        this.price_excl = this.element.data('price_excl');
        this.price_incl = this.element.data('price_incl');
        this.initial_total = this.element.data('initial_total');
        this.webshop_type = this.element.data('webshop-type');

        this.total = 0;
        this.reached = false;
        this.is_visible = false;
        // when we selected a product etc from this deal, this deal is complete
        this.is_complete = this.element.data('is_complete');

        this.selected_product_id = null;

        this.callbacks = {};

        this.setTotal(this.initial_total);
        this.events();

        this.element.find('.no-product-warning').hide().removeClass('d-none');
        this.alertTimeout = false;

        // simple config for if we want to use a claim button or not.
        this.useClaimButton = false;

        if(this.useClaimButton === false) {
            this.element.find('.claim-product').addClass('d-none');
        }
    }

    /**
     * sets the total for the bonus deal panel
     * @param {float} total 
     */
    setTotal(total) {
        this.total = parseFloat(total);

        // reset visibility of this module
        if(this.goal - this.total > 0) {

            if(this.is_complete) {
                this.dispatch('regress');
            }

            this.is_visible = true;
            this.is_complete = false;
        }

        this.refresh();
    }

    refresh() {
        this.toggleVisibility();
        this.showProducts();
        this.setProgress(this.percentage);
        this.setRemainingAmount();
    }

    setRemainingAmount() {

        let remaining = this.goal - this.total;

        remaining = getLocalePrice(remaining);

        this.element.find('.remaining-amount').html(remaining)
    }

    get goal() {
        let key = "price_excl";

        if(this.webshop_type == "B2C") {
            key = "price_incl";
        }

        return parseFloat(this[key].toFixed(2));
    }

    get percentage() {
        let percentage = (100 / this.goal) * this.total
        if(percentage > 100) {
            percentage = 100;
        }

        return percentage;
    }
    
    showProducts() {

        this.reached = false;
        if(this.total >= this.goal) {
            this.reached = true;
        }

        this.toggleProducts();
    }

    setProgress(percentage) {
        // we delay setting the percentage bar slightly, to ensure the transition plays
        setTimeout(() => {
            this.element.find('.meter-bar-progress').css({width: `${percentage}%`});
        }, 1);
    }

    toggleProducts() {

        if(this.reached) {
            this.element.find('.reached').removeClass('d-none');
            this.element.find('.not-reached').addClass('d-none');
        } else {
            this.element.find('.not-reached').removeClass('d-none');
            this.element.find('.reached').addClass('d-none');
        }
    }

    toggleVisibility() {
        this.element.removeClass('d-none')
        this.is_visible = true;

        let priceCheck = this.display_after_value;

        if(config.webshop.type == "B2C") {
            priceCheck *= ((100 + parseInt(config.webshop.vat.high)) / 100);
        }

        if ((this.display_after_type == "fixed" && priceCheck > this.total) ||
        (this.display_after_type == "percentage" && this.display_after_value > this.percentage)
        ) {
            this.element.addClass('d-none')
            this.is_visible = false;
        }
    }
    
    hide() {
        this.element.addClass('d-none')
        this.is_visible = false;
    }

    show() {
        this.is_visible = true;
        this.toggleVisibility();
    }

    events() {
        const self = this;

        this.element.find('.card-bonus-deal').on('click', function() {
            self.resetSelectedProduct();
            $(this).addClass('selected');
            self.selected_product_id = $(this).data('product_id');
            self.element.find('.claim-product').removeClass('disabled').removeAttr('disabled');

            if(self.useClaimButton === false) {
                self.addToCart(self.selected_product_id);
            }

        });

        this.element.find('.show-more').on('click', function () {
            let showMore = $(this).find('.open-show-more');
            let close = $(this).find('.close-show-more');

            showMore.toggleClass('d-none');
            close.toggleClass('d-none');
        });

        this.element.find('.claim-product').on('click', function() {
            if (self.selected_product_id == null) {
                self.showAlert();
                return;
            }

            self.addToCart(self.selected_product_id);
        });
    }

    addToCart(productId) {

        const self = this;

        $.ajax({
            url: config.domain + '/frontend/functions/bonus_deal_add_product.php',
            type: 'post',
            data: {
                "product_id": productId,
                "bonus_deal_id": this.id,
            },
            success: function (response) {
                self.is_complete = true;

                response = JSON.parse(response);

                self.hide();
                self.dispatch('completed', response);
            }
        });

    }

    showAlert() {
        this.element.find('.no-product-warning').fadeIn(200);

        if(this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }

        this.alertTimeout = setTimeout(() => {
            this.element.find('.no-product-warning').fadeOut(200);
        }, 5000)
    }

    resetSelectedProduct() {
        this.element.find('.card-bonus-deal.selected').removeClass('selected');
        this.element.find('.claim-product').addClass('disabled').attr('disabled', true);
    }

    on(event, callback) {
        this.callbacks[event] = callback;
    }

    dispatch(event, ...parameters) {
        if  (event in this.callbacks) {
            return this.callbacks[event](...parameters);
        }
    }

}